export default {
  label: "Lehre",
  portal: { label: "Portal" },
  moodleModulUpdateForm: {
    from: "von",
    to: "bis",
  },
};
